module.exports = {
	"Search the video": "Videoda ara",
	"Explore": "Keşfet",
	"Print": "Yazdır",
	"Download": "İndir",
	"Share": "Paylaş",
	"Settings": "Ayarlar",
	"Language": "Dil",
	"Interface Language": "Arayüz Dili",
	"Transcript / Captions Language": "Transkript / Altyazı Dili",
	"Transcript Language": "Transkript Dili",
	"Captions Language": "Altyazı Dili",
	"Show Transcript": "Transkripti Göster",
	"Show Captions": "Altyazıları Göster",
	"Show Heatmap": "Isı Haritasını Göster",
	"Show Speakers in Transcript": "Transkriptte Konuşmacıları Göster",
	"Keyword": "Anahtar Kelime",
	"Keywords": "Anahtar Kelimeler",
	"Topic": "Konu",
	"Topics": "Konular",
	"Speaker": "Konuşmacı",
	"Speakers": "Konuşmacılar",
	"Transcript": "Transkript",
	"Previous": "Önceki",
	"Next": "Sonraki",
	"Clear": "Temizle",
	"No results found": "Sonuç bulunamadı",
	"try another search or explore": "başka bir arama yap ya da keşfet",
	"Share Search": "Arama Sonuçlarını Paylaş",
	"Share Time": "Süreyi Paylaş",
	"There is no transcript available in the selected language.": "Seçilen dilde metin bulunmamaktadır.",
	"Show {{count}} more": "{{count}} fazla sonuç göster",
	"Show {{count}} more_plural": "{{count}} fazla sonuç göster"
};


//////////////////
// WEBPACK FOOTER
// ./locale/tr.json
// module id = ./locale/tr.json
// module chunks = 0 1